module.exports = __webpack_public_path__ + "static/img/Rectangle.55eac7c2.svg";